import moment from 'moment'

function yearBCtoAD (yearBC) {
  return parseInt(yearBC, 10) + 543
}

function monthDigitToTHName (digit) {
  switch (digit) {
    case '01':
      return 'มกราคม'
    case '02':
      return 'กุมภาพันธ์'
    case '03':
      return 'มีนาคม'
    case '04':
      return 'เมษายน'
    case '05':
      return 'พฤษภาคม'
    case '06':
      return 'มิถุนายน'
    case '07':
      return 'กรกฎาคม'
    case '08':
      return 'สิงหาคม'
    case '09':
      return 'กันยายน'
    case '10':
      return 'ตุลาคม'
    case '11':
      return 'พฤศจิกายน'
    case '12':
      return 'ธันวาคม'
  }
}

function getTodayTH () {
  let [day, month, year] = moment().format('DD-MM-YYYY').split('-')
  return `${day} ${monthDigitToTHName(month)} ${yearBCtoAD(year)}`
}

export {
  monthDigitToTHName,
  yearBCtoAD,
  getTodayTH
}
